module.exports = __webpack_public_path__ + "static/media/bear.c3331331.svg";